/** camelCase keys: start with a lowercase letter, letters and numbers only. */
export const ATTR_KEY_FORMAT_RE = /^[a-z][a-zA-Z0-9]*$/;

export const isValidAttributeKey = (key: string): boolean => ATTR_KEY_FORMAT_RE.test(key.trim());

/**
 * Label -> camelCase Key, matching the existing registry's key convention
 * (e.g. 'userCity', 'ageRange'). Splits on any non-alphanumeric run AND on
 * existing camelCase boundaries (so 'alreadyCamelCase' round-trips instead
 * of flattening to 'alreadycamelcase'), then re-joins camelCase.
 */
export const slugifyFieldKey = (label: string): string => {
  const words = label
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .split(/[^a-zA-Z0-9]+/)
    .filter(Boolean);

  if (words.length === 0) return '';

  return words
    .map((word, index) => {
      const lower = word.toLowerCase();
      return index === 0 ? lower : lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join('');
};
